import { render, staticRenderFns } from "./jifenGive.vue?vue&type=template&id=fcfd0912&scoped=true"
import script from "./jifenGive.vue?vue&type=script&lang=js"
export * from "./jifenGive.vue?vue&type=script&lang=js"
import style0 from "./jifenGive.vue?vue&type=style&index=0&id=fcfd0912&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcfd0912",
  null
  
)

export default component.exports